import React, { useState, useRef } from 'react';
import { Play, Pause, Volume2 } from 'lucide-react';
interface AudioPlayerProps {
  src: string;
  title: string;
  subtitle?: string;
}
export function AudioPlayer({
  src,
  title,
  subtitle
}: AudioPlayerProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  return <div className="bg-white border border-[#E8E8E6] rounded-xl p-4 flex items-center gap-4 shadow-sm" data-id="element-42">
      <button onClick={togglePlay} className="w-12 h-12 rounded-full bg-[#5BBFB5] text-white flex items-center justify-center hover:bg-[#4DAF9F] transition-colors shrink-0" data-id="element-43">
        {isPlaying ? <Pause className="w-5 h-5" data-id="element-44" /> : <Play className="w-5 h-5 ml-1" data-id="element-45" />}
      </button>

      <div className="flex-1 min-w-0" data-id="element-46">
        <h4 className="font-medium text-[#3A3A3A] truncate" data-id="element-47">{title}</h4>
        {subtitle && <p className="text-sm text-[#7A7A7A] truncate font-light" data-id="element-48">
            {subtitle}
          </p>}
      </div>

      <div className="text-[#5BBFB5]" data-id="element-49">
        <Volume2 className="w-5 h-5" data-id="element-50" />
      </div>

      <audio ref={audioRef} src={src} onEnded={() => setIsPlaying(false)} className="hidden" data-id="element-51" />
    </div>;
}